<template>
  <div>
    <configurar-associacao-fila-status-ticket-dialog
      :is-configurar-associacao-fila-status-ticket-dialog-open.sync="isAddNewStatusSidebarActive"
      :categorias-permitidas="categoriasPermitidas"
      :ordens-permitidas="ordensPermitidas"
      :ja-possui-status-em-andamento-principal="jaPossuiStatusEmAndamentoPrincipal"
      @refetch-data="setData"
    />

    <contadores
      :total="contadores.total"
      :ativos="contadores.ativos"
      :inativos="contadores.inativos"
      @alterarFiltro="atualizarFiltro"
    />

    <v-card
      flat
      class="pa-3 mt-2"
    >
      <v-card class="d-flex justify-space-between">
        <v-card-title>Status</v-card-title>
        <v-btn
          v-if="!jaCadastrouTodasAsOrdens && !acessoPost"
          color="primary"
          class=" ma-3"
          disabled
        >
          <span>Adicionar</span>
        </v-btn>
        <v-btn
          v-else
          color="primary"
          class=" ma-3"
          @click="isAddNewStatusSidebarActive = !isAddNewStatusSidebarActive"
        >
          <span>Adicionar</span>
        </v-btn>
      </v-card>

      <div style="min-height: 4px">
        <v-progress-linear
          v-if="loading"
          indeterminate
          @refetch-data="setData"
        />
      </div>

      <table-associacao-fila-status
        :items="filaStatusTicket"
        :acesso-disable="acessoDisable"
        @refetch-data="setData"
      />
    </v-card>
  </div>
</template>

<script>
import { ref, onMounted, computed } from '@vue/composition-api'
import { mapState } from 'pinia'
import ConfigurarAssociacaoFilaStatusTicketDialog from './ConfigurarAssociacaoFilaStatusTicketDialog.vue'
import TableAssociacaoFilaStatus from './TableAssociacaoFilaStatus.vue'
import Contadores from '@/components/contadores/Contadores.vue'
import router from '@/router'
import useAuthStore from '@/store/auth'
import FilaService from '@/services/modules/FilaService'
import CategoriasStatusService from '@/services/modules/CategoriasStatusService'
import TicketCategoriaStatusEnum from '@/models/entities/ticket/TicketCategoriaStatusEnum'

export default {
  components: {
    ConfigurarAssociacaoFilaStatusTicketDialog,
    TableAssociacaoFilaStatus,
    Contadores,
  },

  props: {
    ativo: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      idPost: 2006,
      acessoPost: true,
      idDisable: 2007,
      acessoDisable: true,
    }
  },

  computed: {
    ...mapState(useAuthStore, ['funcionalidades']),
  },

  mounted() {
    this.permissoes()
  },

  methods: {
    permissoes() {
      if (!this.funcionalidades.includes(this.idPost)) {
        this.acessoPost = false
      }
      if (!this.funcionalidades.includes(this.idDisable)) {
        this.acessoDisable = false
      }
    },
  },

  setup() {
    // Lista completa (ativos + inativos), usada pelas validacoes do formulario de adicionar status
    // -- ordem e categoria ja usadas valem pros inativos tambem, nao so pro que esta visivel na tela.
    const filaStatusTicketTodos = ref([])

    // Lista exibida na tabela, recortada pelo filtro de status (Ativos por padrao).
    const filaStatusTicket = ref([])
    const filtroStatus = ref('true')
    const contadores = ref({ total: 0, ativos: 0, inativos: 0 })

    const jaPossuiStatusEmAndamentoPrincipal = computed(() => filaStatusTicketTodos.value.some(it => it.categoriaStatusId === TicketCategoriaStatusEnum.Andamento && it.principal))
    const categoriasPermitidas = ref([])
    const ordensPermitidas = ref([])
    const jaCadastrouTodasAsOrdens = ref(undefined)

    function aplicarFiltro() {
      contadores.value.total = filaStatusTicketTodos.value.length
      contadores.value.ativos = filaStatusTicketTodos.value.filter(it => it.ativo).length
      contadores.value.inativos = filaStatusTicketTodos.value.filter(it => !it.ativo).length

      filaStatusTicket.value = filtroStatus.value
        ? filaStatusTicketTodos.value.filter(it => it.ativo.toString() === filtroStatus.value)
        : filaStatusTicketTodos.value
    }

    async function getFilaStatusTicket() {
      filaStatusTicketTodos.value = await FilaService.getFilaStatusTicket(router.currentRoute.params.id)
      aplicarFiltro()
    }
    async function getCategoriasPermitidas() {
      categoriasPermitidas.value = await CategoriasStatusService.getCategoriasStatus()
      const possuiStatusFinalizado = ref(filaStatusTicketTodos.value.find(s => s.categoriaStatusNome === 'Finalizado') !== undefined)
      if (possuiStatusFinalizado.value) {
        categoriasPermitidas.value = categoriasPermitidas.value.filter(c => c.nome !== 'Finalizado')
      }
    }
    async function setOrdensPermitidas() {
      const ordensDeOutrosStatus = ref(filaStatusTicketTodos.value.map(s => s.ordem))

      if (ordensDeOutrosStatus.value.length === 50) {
        jaCadastrouTodasAsOrdens.value = true
      } else {
        jaCadastrouTodasAsOrdens.value = false
      }

      if (!jaCadastrouTodasAsOrdens.value) {
        ordensPermitidas.value = [...Array(50).keys()]
          .map(n => n + 1)
          .filter(n => !ordensDeOutrosStatus.value.some(o => o === n))
      }
    }
    async function setData() {
      await getFilaStatusTicket()
      await getCategoriasPermitidas()
      await setOrdensPermitidas()
    }
    onMounted(setData)

    function atualizarFiltro(item) {
      filtroStatus.value = item
      aplicarFiltro()
    }

    const loading = ref(false)
    const isAddNewStatusSidebarActive = ref(false)

    return {
      filaStatusTicket,
      contadores,
      atualizarFiltro,
      jaPossuiStatusEmAndamentoPrincipal,
      categoriasPermitidas,
      ordensPermitidas,
      jaCadastrouTodasAsOrdens,
      setData,
      loading,
      isAddNewStatusSidebarActive,
    }
  },
}
</script>
